import React from "react";

const InfoBlock = () => {
    return (
        <section>
            <p>
                <strong>Notice!</strong>
            </p>
            <p>
                Application for Performance Marketing Diamonds CEE 2021 is connected with the obligation to pay a fee in
                the amount of:
            </p>
            <ol>
                <li>
                    Members or Partners of e-Chamber of Digilal Economy:
                    <ul>
                        <li>499 PLN netto for each category in term (12.01-26.01.2021) </li>
                        <li>699 PLN netto for each category in term (27.01-01.03.2021) </li>
                        <li>999 PLN netto for each category in term (02.03-11.03.2021) </li>
                    </ul>
                </li>
                <li>
                    Companies not affiliated to the e-Chamber of Digital Economy
                    <ul>
                        <li>1499 PLN netto for each category in term (12.01-26.01.2021) </li>
                        <li>1699 PLN netto for each category in term (27.01-01.03.2021) </li>
                        <li>1999 PLN netto for each category in term (02.03-11.03.2021) </li>
                    </ul>
                </li>
            </ol>
            <p>
                The amounts increased by 23% VAT must be paid to the bank account of the Organizer
                (PKO BP SA Branch 1 in Warsaw), number <strong>79 1020 1013 0000 0302 0291 6963</strong>.
            </p>
        </section>
    );
};

export default InfoBlock;
